<template>
	<div>
		<p>
			{{
				selectRandom(["We searched ", "Databases used for the search were "])
			}}
			{{ joinArrayWithAnd(formatSelectMulti($tera.project.databases)) }}
			{{
				selectRandom([
					"from ",
					". Searchers were run from ",
					". Databases were searched from "
				])
			}}
			{{
				$tera.project.dateSearchedUntil
					? formatDateFull($tera.project.dateSearchedUntil)
					: "inception"
			}}
			{{ selectRandom(["to ", "until "]) }}
			{{
				$tera.project.dateOfSearch
					? formatDateFull($tera.project.dateOfSearch)
					: "BLANK"
			}}
			(see Appendix X).
		</p>

		<!--Appendix : showAll: FALSE unless it in the ViewOutput (All Appendix are gathered together showing at the bottom)-->
		<div v-if="showAppendix">
			<OutputAppendix method="SearchStrings" :showAll="false" />
		</div>
	</div>
</template>

<script>
import OutputMixin from "@/mixins/OutputMixin.js";
import OutputAppendix from "./OutputAppendix.vue";
export default {
	name: "OutputSearchStrings",
	mixins: [OutputMixin],
	components: {
		OutputAppendix
	},
	props: {
		showAppendix: Boolean
	},
	methods: {
		getSearchString(database) {
			console.log("output:", this.$tera.project.outputVersions);
			return database.manualVersion; //return final Version
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
